import { ApiResponse, useFetch } from '@/api/useFetch';
import {
  ActivityCategoriesResponse,
  ChangeMobileNumberPayload,
  ChangePasswordPayload,
  CitiesResponse,
  MeResponse,
  PatchProfile,
  ProfileResponse,
  ProvincesResponse,
  UpdateProfile,
} from '@/pages/Profile/Profile.types';
import { ApiMethod } from '@/types/enums';
import { ApiSuccessResponse, AuthApiOkResponse } from '@/types/shared';

export const useGetProvinces = async (): Promise<ApiResponse<ProvincesResponse>> => {
  return useFetch('api/provinces', {
    method: ApiMethod.Get,
  });
};

export const useGetCities = async (provinceId: number): Promise<ApiResponse<CitiesResponse>> => {
  return useFetch(`api/${provinceId}/cities`, {
    method: ApiMethod.Get,
  });
};

export const useGetActivityCategories = async (): Promise<ApiResponse<ActivityCategoriesResponse>> => {
  return useFetch('api/activityCategories', {
    method: ApiMethod.Get,
  });
};

export const useGetProfile = async (): Promise<ApiResponse<ProfileResponse>> => {
  return useFetch('api/profile', {
    method: ApiMethod.Get,
  });
};

export const useUpdateProfile = async (body: UpdateProfile): Promise<ApiResponse<ApiSuccessResponse>> => {
  return useFetch('api/profile', {
    method: ApiMethod.Post,
    body: JSON.stringify(body),
  });
};

export const usePatchProfile = async (body: PatchProfile): Promise<ApiResponse<ApiSuccessResponse>> => {
  return useFetch('api/profile', {
    method: ApiMethod.Patch,
    body: JSON.stringify(body),
  });
};

export const useChangePassword = async (body: ChangePasswordPayload): Promise<ApiResponse<AuthApiOkResponse>> => {
  return await useFetch('auth/api/password-change', {
    method: ApiMethod.Post,
    body: JSON.stringify(body),
  });
};

export const useChangeMobileNumber = async (
  body: ChangeMobileNumberPayload,
): Promise<ApiResponse<AuthApiOkResponse>> => {
  return await useFetch('auth/api/mobile-change', {
    method: ApiMethod.Post,
    body: JSON.stringify(body),
  });
};

export const useGetMe = async (): Promise<ApiResponse<MeResponse>> => {
  return useFetch('api/me', {
    method: ApiMethod.Get,
  });
};
